import type { NavigationPagesHook } from "@src/components/widgets/AppSubNav/hooks/types";
import { usePathname } from "next/navigation";
import { useMemo } from "react";

export function useNavigationPages(
  allPages: NavigationPagesHook["allPages"],
  activePageSource: "allPages" | "visiblePages" = "visiblePages",
) {
  const pathname = usePathname();

  const visiblePages = useMemo(() => {
    return allPages.filter(({ hidden }) => !hidden);
  }, [allPages]);

  const activePage = useMemo(() => {
    if (activePageSource === "visiblePages")
      return visiblePages.find(({ href }) =>
        pathname.startsWith(href.pathname),
      );

    return allPages.find(({ href }) => pathname.startsWith(href.pathname));
  }, [allPages, pathname]);

  const activeSubpage = useMemo(() => {
    return activePage?.subPages?.find(({ href }) =>
      pathname.startsWith(href.pathname),
    );
  }, [activePage?.subPages, pathname]);

  return {
    allPages,
    activePage,
    activeSubpage,
    visiblePages,
  };
}
